export function setDefaultValue(schema, name, value) {
    const elements = schema.configuration?.elements;
    if (!Array.isArray(elements)) return;

    const queue = [...elements];

    while (queue.length > 0) {
        const element = queue.shift();

        if ('elements' in element && Array.isArray(element.elements)) {
            queue.push(...element.elements);
        }

        if (!('identifier' in element)) continue;

        const id = element.identifier;
        if (id !== name) continue;

        element.defaultValue = value;
    }
}